// extracted by mini-css-extract-plugin
export default {"Blankslate":"dacRd","iconNode":"Vr74a","content":"Qwmw7","message":"Wr3no","iconSize-144":"A9AfZ","inline":"Y3Grf","spacious":"o6alb","middle":"Oz6uE"};